import { PageModel, API, Project, ProjectAPI } from "@brg/api";
import { BookType } from "_deziiign/books/constants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const useProjectChapters = (project: Project<'Global'>) => {
   const [chapters, setChapters] = useState<Project[]>([]);
   const { i18n: { language }} = useTranslation();

   useEffect(() => {
    if (project?.bookType === BookType.playbook) {
        ProjectAPI.GetList({
            bookId: project?.projectId,
            projectFilter: 8,
            isLite: false,
            isContextIgnored: true
        }).then((data) => data.json() as Promise<PageModel<Project<"Global">>>)
        .then((data) => API.toLang<PageModel<Project>>(data, language))
        .then((data) => {
            setChapters(data.data);
        });
    }
   }, [project?.projectId, language]);

   return chapters;
}

export default useProjectChapters;import { PageModel, API, Project, ProjectAPI } from "@brg/api";
import { BookType } from "_deziiign/books/constants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const useProjectChapters = (project: Project<'Global'>) => {
   const [chapters, setChapters] = useState<Project[]>([]);
   const { i18n: { language }} = useTranslation();

   useEffect(() => {
    if (project?.bookType === BookType.playbook) {
        ProjectAPI.GetList({
            bookId: project?.projectId,
            projectFilter: 8,
            isLite: false,
            isContextIgnored: true
        }).then((data) => data.json() as Promise<PageModel<Project<"Global">>>)
        .then((data) => API.toLang<PageModel<Project>>(data, language))
        .then((data) => {
            setChapters(data.data);
        });
    }
   }, [project?.projectId, language]);

   return chapters;
}

export default useProjectChapters;